module.exports = __webpack_public_path__ + "img/812E39_551C24_381117_9E3C49-256px.f6ed6be5.png";